import { Card, View } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Star } from "@/components/shared/icons";
import { Typography } from "@/components/shared/typography";
import { PackageDepartmentEnum } from "@/__generated__/graphql";
import { WorkerAvatar } from "@/components/shared/worker-avatar";

export const AvatarTimeSlotCard = ({
  timeRange,
  workerName,
  active,
  workerRating,
  avatarUrl,
  onCardClick,
  onClickProfolio,
  department,
}: {
  timeRange: string;
  workerName: string;
  workerRating: number;
  avatarUrl: string;
  active?: boolean;
  onCardClick?: () => void;
  onClickProfolio: () => void;
  department: PackageDepartmentEnum;
}) => {
  const isElderCare = department === PackageDepartmentEnum.ElderCare;
  const textProfile = isElderCare ? "View Profile" : "Portfolio";
  return (
    <Card
      className={cn(
        "grow-0 cursor-pointer items-center p-3 hover:divide-primary-border hover:bg-primary-surface",
        {
          "border-primary-border bg-primary-surface": active,
        },
      )}
      gap="md"
      onClick={onCardClick}
    >
      <View className="border-b border-secondary-border pb-2">
        <Typography variant="body-sm">{timeRange}</Typography>
      </View>
      <WorkerAvatar src={avatarUrl} size={32} />
      <View className="flex flex-col items-center gap-1">
        <Typography color="foreground-intermediate" variant="body-sm">
          {workerName}
        </Typography>
        <View className="flex cursor-pointer flex-row items-center">
          <View
            className="native:border-solid native:border-transparent flex flex-row divide-x border-b web:border-dashed"
            onClick={onClickProfolio}
          >
            {!isElderCare && (
              <View className="flex flex-row items-center gap-[2px]">
                <Star weight="fill" className="color-warning" size={12} />
                <Typography variant="caption-md" color="info" className="mr-1">
                  {workerRating
                    ? `${parseFloat(workerRating.toFixed(1))}/5`
                    : "-"}
                </Typography>
              </View>
            )}
            <Typography variant="caption-md" color="info" className="pl-1">
              {textProfile}
            </Typography>
          </View>
        </View>
      </View>
    </Card>
  );
};
